import ExtendableError from '../lib/ExtendableError';
import _ from 'lodash';


function _getErrorMessage(errors = []) {
    const cocsError = (e) => e.code && `${e.code}: ${e.message}`;
    const jpError = (e) => e.failureType && `${e.failureType}: ${e.errorCode}`;

    const messages = [].concat(errors).map(
        (e) => !!e && (cocsError(e) || jpError(e))
    ).filter((message) => !!message);

    return messages.length ? messages.join(', ') : null;
}

// Some APIs (e.g. payments) reply with { message, code } instead of { errors: [...] }.
// Only the code is used: the message text can carry ids (e.g. the order), which would
// split one Sentry issue into one per order.
function _getTopLevelCode(body) {
    return typeof body.code === 'string' && body.code ? body.code : null;
}

export class ApiError extends ExtendableError {
    constructor (response, body, context) {
        const apiMessage = body && (_getErrorMessage(body.errors) || _getTopLevelCode(body));
        const httpError = response && response.statusText;
        super(apiMessage || httpError || 'Server Error', context);
        this.response = response;
        this.body = body;
    }
    name = 'ApiError';

    hasCode(code) {
        return _.findIndex(this.body.errors, ['code', code]) !== -1;
    }
}

export class RequestError extends ApiError {
    name = 'RequestError';
}

export class ServerError extends ApiError {
    name = 'ServerError';
}

export class UnauthorisedError extends ApiError {
    name = 'UnauthorisedError';
}

export class ForbiddenError extends ApiError {
    name = 'ForbiddenError';
}

export class NotFoundError extends RequestError {
    name = 'NotFoundError';
}

export class BadRequestError extends RequestError {
    name = 'BadRequest';
}
